import { urlParse } from "./utils";

//данные адреса клиента
let t = process.env.CLIENT_URL;
if ( !t ) {
	t = process.env.VUE_APP_PUBLIC_PATH;
	if ( t ) t = t.replace(/\/+$/, "" ) + "/";
}
if ( !t ) t = "http://127.0.0.1:8080";
const client = urlParse( t );
if ( client === null ) {
	console.log( "ERROR: CLIENT_URL must be something like \"http://127.0.0.1:8080/a/b/c?def\" or \"/a/b/c?def\"" );
}

//данные адреса backend-сервера для клиента
t = process.env.SERVER_URL;
if ( !t ) {
	t = process.env.VUE_APP_API_URL;
	if ( t ) t = t.replace(/\/+$/, "" ) + "/";
}
if ( !t ) t = "http://127.0.0.1:8090";
const server = urlParse( t );
if ( server === null ) {
	console.log( "ERROR: SERVER_URL must be something like \"http://127.0.0.1:8090/a/b/c?def\" or \"/a/b/c?def\"" );
}

const autoML = {
	url:			"/autoML",
	user:			null,
	password:	null
};

t = process.env.AUTOML_URL;
if ( !t ) t = process.env.VUE_APP_AUTOML_URL;
if ( t ) autoML.url = t;

t = process.env.AUTOML_USER;
if ( !t ) t = process.env.VUE_APP_AUTOML_USER;
if ( t ) autoML.user = t;

if ( autoML.user ) {
	t = process.env.AUTOML_PASSWORD;
	if ( !t ) t = process.env.VUE_APP_AUTOML_PASSWORD;
	if ( t ) autoML.password = t;
}

const KazNIISA = {
	url:			"/KazNIISA",
	reportUrl:"/KazNIISA"
};
t = process.env.KAZNIISA_URL;
if ( !t ) t = process.env.VUE_APP_KAZNIISA_URL;
if ( t ) KazNIISA.url = t;

t = process.env.KAZNIISA_REPORT_URL;
if ( !t ) t = process.env.VUE_APP_KAZNIISA_REPORT_URL;
if ( t ) KazNIISA.reportUrl = t;

const AstanaHUB = {
	url: process.env.ASTANAHUB_URL || "http://82.151.213.85:6040/nlu_astana_hub/parse_file"
};

export default {
	client,
	server,
	autoML,
	KazNIISA,
	AstanaHUB,
	limit: 5,
	chunkSize: 500
};
